<template>
  <fragment>
    <div
      class="geral-dados-config animate__animated animate__fadeIn animate__delay-0.5s"
    >
      <div class="config-plus">
        <v-container class="px-0 py-4 mb-8" fluid>
          <v-row class="mb-n15 ml-1 mt-3">
            <h1 class="cookies-text mb-n2">Política de Privacidade</h1>
          </v-row>
          <v-row class="justify-end mb-3 mr-1">
            <v-btn
              height="45"
              @click="
                $omnichannel.openModal(
                  'modal-body-politicas',
                  'new',
                  'policy',
                  '',
                  ''
                )
              "
              class="button btn-border"
              :disabled="policiesIsEmpty"
            >
              <v-icon dark> mdi-plus </v-icon>
              Adicionar política de privacidade
            </v-btn>
          </v-row>
          <v-row class="mb-5">
            <v-divider></v-divider>
          </v-row>
          <v-simple-table
            fixed-header
            class="omnichannel-configs-container"
            v-if="$omnichannel.cadastro.politica_privacidade.length >= 1"
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th
                    v-for="(header, index) in headersPoliticas"
                    :key="index"
                    class="text-center table-header"
                  >
                    {{ header.title }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(policy, index) in $omnichannel.cadastro
                    .politica_privacidade"
                  :key="index"
                >
                  <td class="table-width text-center">
                    {{ $config.convertTagString(policy.titulo) }}
                  </td>
                  <td class="table-actions">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :color="$config.dados.corinputs"
                          height="30"
                          width="30"
                          small
                          icon
                          v-bind="attrs"
                          v-on="on"
                          @click="
                            $omnichannel.openModal(
                              'modal-body-politicas',
                              'edit',
                              'policy',
                              policy,
                              index
                            )
                          "
                          class="mr-2"
                        >
                          <v-icon>mdi-pencil-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :color="$config.dados.corinputs"
                          height="30"
                          width="30"
                          small
                          icon
                          v-bind="attrs"
                          v-on="on"
                          @click="
                            $omnichannel.remover(
                              index,
                              'policy',
                              '',
                              'Deseja realmente excluir esta politica?'
                            )
                          "
                        >
                          <v-icon>mdi-delete-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Deletar</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-row class="ml-2 mt-3 mb-10" v-else>
            <span>Não há registro de políticas de privacidade.</span>
          </v-row>
        </v-container>
        <v-container class="px-0 py-8 mb-8">
          <v-row class="mb-n15 ml-1 mt-3">
            <h1 class="cookies-text mb-n2">Políticas de Cookies</h1>
          </v-row>
          <v-row class="justify-end mb-4 mr-1">
            <v-btn
              height="48"
              @click="
                $omnichannel.openModal(
                  'modal-body-politicas-cookies',
                  'new',
                  'cookies',
                  null
                )
              "
              class="button btn-border btn-right"
              :disabled="cookieIsEmpty"
            >
              <v-icon dark> mdi-plus </v-icon>
              Adicionar políticas de cookies
            </v-btn>
          </v-row>
          <v-row class="mb-5">
            <v-divider></v-divider>
          </v-row>
          <v-simple-table
            fixed-header
            class="omnichannel-configs-container"
            v-if="$omnichannel.cadastro.politicas_cookies.length >= 1"
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th
                    v-for="(header, index) in headersCookies"
                    :key="index"
                    class="text-center table-header"
                  >
                    {{ header.title }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(cookies, index) in $omnichannel.cadastro
                    .politicas_cookies"
                  :key="index"
                >
                  <td class="table-width text-center">
                    {{ $config.convertTagString(cookies.titulo) }}
                  </td>
                  <td class="table-actions">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :color="$config.dados.corinputs"
                          height="30"
                          width="30"
                          small
                          icon
                          v-bind="attrs"
                          v-on="on"
                          @click="
                            $omnichannel.openModal(
                              'modal-body-politicas-cookies',
                              'edit',
                              'cookies',
                              cookies,
                              index
                            )
                          "
                          class="mr-2"
                        >
                          <v-icon> mdi-pencil-outline </v-icon>
                        </v-btn>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :color="$config.dados.corinputs"
                          height="30"
                          width="30"
                          small
                          icon
                          v-bind="attrs"
                          v-on="on"
                          @click="
                            $omnichannel.remover(
                              index,
                              'cookies',
                              Object.keys(cookies)[0],
                              'Deseja realmente excluir esta politica de cookies?'
                            )
                          "
                        >
                          <v-icon> mdi-delete-outline </v-icon>
                        </v-btn>
                      </template>
                      <span>Deletar</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-row class="ml-2 mt-3 mb-10" v-else>
            <span>Não há registro de políticas de cookies.</span>
          </v-row>
        </v-container>
        <v-container class="px-0 py-8 mb-8">
          <v-row class="mb-n15 ml-1 mt-3">
            <h1 class="cookies-text mb-n2">Termo de Compra</h1>
          </v-row>
          <v-row class="justify-end mb-4 mr-1">
            <v-btn
              height="48"
              @click="
                $omnichannel.openModalTermo(
                  'modal-body-termo-compra',
                  'new',
                  null
                )
              "
              class="button btn-border btn-right"
              :disabled="termoIsEmpty"
            >
              <v-icon> mdi-plus </v-icon>
              Adicionar termo de compra
            </v-btn>
          </v-row>
          <v-row class="mb-5">
            <v-divider></v-divider>
          </v-row>
          <v-simple-table
            fixed-header
            class="omnichannel-configs-container"
            v-if="$omnichannel.cadastro.termo_compra.length >= 1"
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th
                    v-for="(header, index) in headersCookies"
                    :key="index"
                    class="text-center table-header"
                  >
                    {{ header.title }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(termo, index) in $omnichannel.cadastro.termo_compra"
                  :key="index"
                >
                  <td class="table-width text-center">
                    {{ $config.convertTagString(termo.titulo) }}
                  </td>
                  <td class="table-actions">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :color="$config.dados.corinputs"
                          height="30"
                          width="30"
                          small
                          icon
                          v-bind="attrs"
                          v-on="on"
                          @click="
                            $omnichannel.openModalTermo(
                              'modal-body-termo-compra',
                              'edit',
                              termo,
                              index
                            )
                          "
                          class="mr-2"
                        >
                          <v-icon> mdi-pencil-outline </v-icon>
                        </v-btn>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :color="$config.dados.corinputs"
                          height="30"
                          width="30"
                          small
                          icon
                          v-bind="attrs"
                          v-on="on"
                          @click="
                            $omnichannel.remover(
                              index,
                              'termo',
                              Object.keys(termo)[0],
                              'Deseja realmente excluir este termo de compra?'
                            )
                          "
                        >
                          <v-icon> mdi-delete-outline </v-icon>
                        </v-btn>
                      </template>
                      <span>Deletar</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-row class="ml-2 mt-3 mb-10" v-else>
            <span>Não há registro de termo de compra.</span>
          </v-row>
        </v-container>
        <v-container class="px-0 py-8 mb-8">
          <v-row class="mb-n15 ml-1 mt-3">
            <h1 class="cookies-text mb-n2">Configurações de Template</h1>
          </v-row>
          <v-row class="justify-end mb-4 mr-1">
            <v-btn
              height="48"
              @click="openModalTemplates"
              class="button btn-border btn-right"
            >
              <v-icon dark> mdi-plus </v-icon>
              Adicionar Template
            </v-btn>
          </v-row>
          <v-row class="mb-5">
            <v-divider></v-divider>
          </v-row>
          <v-simple-table
            fixed-header
            class="omnichannel-configs-container"
            v-if="$omnichannel.templates.templatesToSave.length >= 1"
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th
                    v-for="(header, index) in headersTemplates"
                    :key="index"
                    class="text-center table-header"
                  >
                    {{ header.title }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(template, index) in $omnichannel.templates
                    .templatesToSave"
                  :key="index"
                >
                  <td class="table-width text-center">
                    {{ Object.keys(template)[0] }}
                  </td>
                  <td class="table-width text-center">
                    {{ Object.values(template)[0] }}
                  </td>
                  <td class="table-actions">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :color="$config.dados.corinputs"
                          height="30"
                          width="30"
                          small
                          icon
                          v-bind="attrs"
                          v-on="on"
                          class="mr-2"
                          @click="
                            $omnichannel.openModalConfigTemplate(template)
                          "
                        >
                          <v-icon> mdi-pencil-outline </v-icon>
                        </v-btn>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :color="$config.dados.corinputs"
                          height="30"
                          width="30"
                          small
                          icon
                          v-bind="attrs"
                          v-on="on"
                          @click="
                            $omnichannel.remover(
                              index,
                              'template',
                              Object.keys(template)[0],
                              'Deseja realmente excluir este template ODT?'
                            )
                          "
                        >
                          <v-icon> mdi-delete-outline </v-icon>
                        </v-btn>
                      </template>
                      <span>Deletar</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-row class="ml-2 mt-3 mb-10" v-else>
            <span>Não há registro de templates.</span>
          </v-row>
        </v-container>
        <v-container class="px-0 py-4 mb-8">
          <v-row class="mb-2 ml-1 mt-3">
            <h1 class="cookies-text">E-mail de notificação</h1>
          </v-row>
          <v-row>
            <v-divider></v-divider>
          </v-row>
          <v-row class="mt-3">
            <v-col cols="12">
              <label class="input-labels" required>Descrição e-mail </label>
              <v-text-field
                hide-details
                v-model="$omnichannel.cadastro.email_envio_oper"
                solo
                class="textinput"
                placeholder="Insira o e-mail de notificação"
                type="text"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-container>
        <v-container class="px-0 py-4 mb-8">
          <v-row class="mb-2 ml-1 mt-3">
            <h1 class="cookies-text">URL QRCode</h1>
          </v-row>
          <v-row>
            <v-divider></v-divider>
          </v-row>
          <v-row class="mt-3">
            <v-col cols="12">
              <label class="input-labels" required>Descrição URL QRCode </label>
              <v-text-field
                hide-details
                v-model="$omnichannel.cadastro.url_front_qrcode"
                solo
                class="textinput"
                placeholder="Insira a URL do QRCode"
                type="text"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <RegistrationActions :actions="actions" />
    </div>
    <ModalConfirmacao
      :textModal="$omnichannel.text"
      :funcaoModal="$omnichannel.funcao"
      @updateTable="$omnichannel.funcaoRemover"
    />
    <PoliticasAdd />
    <privacyAdd />
    <TermoAdd />
    <TemplatesModal />
  </fragment>
</template>

<script>
export default {
  name: "General",
  components: {
    ModalConfirmacao: () => import("@/components/global/modal-confirmacao.vue"),
    PoliticasAdd: () =>
      import(
        "@/components/configuracoes/modal-configuracoes-politica-cookies.vue"
      ),
    privacyAdd: () =>
      import("@/components/configuracoes/politicas-modal-add-edit.vue"),
    TemplatesModal: () =>
      import("@/components/configuracoes/modal-configuracoes-templates.vue"),
    TermoAdd: () =>
      import("@/components/configuracoes/modal-configuracoes-termo-compra.vue"),
    RegistrationActions: () =>
      import("@/components/global/RegistrationActions.vue"),
  },
  data() {
    return {
      options5: {
        locale: "pt-BR",
        prefix: "R$",
        suffix: "",
        length: 9,
        precision: 2,
      },
      actions: [
        {
          name: "Salvar",
          action: () => this.$omnichannel.validarCadastro(),
        },
        {
          name: "Cancelar",
          action: () => {
            caches.keys().then(function (names) {
              for (let name of names) caches.delete(name);
            });
            localStorage.removeItem("activeIndex");
            this.$router.push("/home");
            location.reload();
          },
        },
      ],
      headersCookies: [
        {
          title: "Descrição",
        },
        {
          title: "Ações",
        },
      ],
      headersPoliticas: [
        {
          title: "Descrição",
        },
        {
          title: "Ações",
        },
      ],
      headersTemplates: [
        {
          title: "Descrição",
        },
        {
          title: "ID do Template",
        },
        {
          title: "Ações",
        },
      ],
    };
  },
  computed: {
    cookieIsEmpty: {
      get() {
        if (
          this.$omnichannel.cadastro.politicas_cookies.length <= 0 ||
          this.$omnichannel.cadastro.politicas_cookies === null ||
          this.$omnichannel.cadastro.politicas_cookies === undefined ||
          this.$omnichannel.cadastro.politicas_cookies === ""
        ) {
          return false;
        }

        return true;
      },
      set() {},
    },
    termoIsEmpty: {
      get() {
        if (
          this.$omnichannel.cadastro.termo_compra.length <= 0 ||
          this.$omnichannel.cadastro.termo_compra === null ||
          this.$omnichannel.cadastro.termo_compra === undefined ||
          this.$omnichannel.cadastro.termo_compra === ""
        ) {
          return false;
        }

        return true;
      },
      set() {},
    },
    policiesIsEmpty: {
      get() {
        if (
          this.$omnichannel.cadastro.politica_privacidade.length <= 0 ||
          this.$omnichannel.cadastro.politica_privacidade === null ||
          this.$omnichannel.cadastro.politica_privacidade === undefined ||
          this.$omnichannel.cadastro.politica_privacidade === ""
        ) {
          return false;
        }
        return true;
      },
      set() {},
    },
    // templateOptionsAddDisabled() {
    //   let hasSomeoneAvailable =
    //     this.$omnichannel.templates.templateOptions.every(
    //       template => template.show === false
    //     );

    //   // isTrue === true - se todos forem false, que não devem ser listados

    //   if (hasSomeoneAvailable) return true;
    //   return false;
    // },
  },
  methods: {
    openModalTemplates() {
      this.$omnichannel.getValidODTTemplates();
      this.$omnichannel.templates.openModalTemplates = true;
    },
  },
  mounted() {
    this.$omnichannel.getConfigOmnichannel();
  },
};
</script>

<style scoped>
.geral-dados-config {
  width: 100%;
  height: 100%;
  align-items: center;
  flex-direction: column;
}
.config-plus {
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
}
.table-width {
  width: 75%;
}
.cookies-text {
  font-size: 1em;
  width: 487px;
  align-self: flex-start;
  margin-top: 20px;
}

.omnichannel-configs-container {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: flex-start;
  border-radius: 20px;
  flex-direction: column;
}

.omnichannel-cadastro-button {
  color: var(--dl-color-gray-white);
  width: 30px;
  height: 30px;
  display: flex;
  padding: 0px;
  align-items: center;
  border-width: 0px;
  margin-right: 10px;
  flex-direction: row;
  justify-content: center;
  background-color: var(--dl-color-gray-black);
}

.config-omnichannel-icon1 {
  fill: var(--dl-color-gray-white);
  width: 24px;
  height: 24px;
}
.info-tool {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 50px;
  margin-left: 0.625rem;
  cursor: pointer;
}

.info-tool-icon {
  fill: #000;
  height: 24px;
  width: 24px;
}
</style>
